import { use_effect } from '@/hooks/_base/use_effect';
import { use_state_ref } from '@/hooks/_base/use_state_ref';
import { use_slice_user } from '@/hooks/store/use_slices';
import { save_url_to_store_for_redirect_after_auth } from '@/utils/utils_client';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { ENUM__page_type } from '../enums/ENUM__page_type';

interface Props {
  page: ReactNode;
}

export function LAYOUT_PAGE__open_auth_if_no_auth_token({ page }: Props) {
  const { auth_token, is_authorized } = use_slice_user(['auth_token', 'is_authorized']);

  const [is_slug_initialized, set_is_slug_initialized, ref_is_slug_initialized] = use_state_ref(false);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (ref_is_slug_initialized.current) return;

    if (!auth_token) save_url_to_store_for_redirect_after_auth();

    set_is_slug_initialized(true);
  }, [auth_token, is_slug_initialized]);

  /*
   * HTML
   */

  if (!is_slug_initialized) return null;
  if (!auth_token) return <Navigate to={ENUM__page_type.AUTH} />;
  if (!is_authorized) return null;

  return page;
}
